import styled from 'styled-components';
import { notchHeight, Format, BaseStyledComponentProps } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';
import UserAgentUtils from '../../utils/userAgent';

interface AppContainerProps {
	hasStatusBar: boolean;
}

const topPadding = (props: AppContainerProps) => props.hasStatusBar ? '20px' : 0;

const AppContainer = styled('div')`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding-top: ${topPadding};
	background-color: ${(props: BaseStyledComponentProps) => {
		const opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
		return hexToRgba(props.theme.primary.topnavColor, opacity);
	}};

	@media ${Format.SmartphonePortrait} and (max-aspect-ratio: 1/2) {
		padding-top: ${UserAgentUtils.isIOS() ? notchHeight : topPadding};
	}
`;

const AppInnerContainer = styled('div')`
	position: relative;
	height: 100%;
`;

export { AppContainer, AppInnerContainer };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/styles.ts